import { Injectable } from '@angular/core';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { constant } from 'app/app.constants';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ManagerReportsService extends ParentService {

  constructor(private _http: Http, private route: Router) {
    super();
    // this.verifyToken(this._http, this.route);
  }

  /**
   * @name getMenuAll
   * @desc Cargar listado de modulos y submodulos
   * @return http
   */
  getMenuReports(usertypeid) {
    return this._http.get(`${constant.URL_MANAGER_REPORTS}/${usertypeid}?ShowMigrated=false`, this.getHeader())
      .map(resp => resp.json());
  }

  generateLogisticareUtsReport(initialDate, finalDate) {
    return this._http
      .get(`${constant.BASIC}Report/CreateLcUtsReport/${initialDate}/${finalDate}`, this.getFileHeaders())
      .catch((error: any) => Observable.throw(error.json()));
  }


  generateDateRangeReport(reportPath, rangeDate, payorId = 0, callTypeIds = null, payorIds = null, providerIds = null, tripStatusIds = null, driverIds = null,
                          isSumary = false, isPost = false, isDateRange = false, isExcel = false) {
    let initialDate, finalDate;
    if (isDateRange)
    {
      initialDate = this.getFormatted(rangeDate.beginDate);
      finalDate = this.getFormatted(rangeDate.endDate);
    }else {
      initialDate = rangeDate.formatted;
    }
    let url = `${constant.BASIC}Report/${reportPath}`;

    if (!isPost) {

      if (payorId !== null && payorId > 0) {
        url = `${url}/${payorId}`;
      }
      url = `${url}/${initialDate}`;
      if(isDateRange) {
        url = `${url}/${finalDate}`;
      }
      return this._http
        .get(url, this.getFileHeaders())
        .catch((error: any) => Observable.throw(error.json()));
    }else {
      const type = isExcel ? 0 : 2;
      const body: any = {
        InitialDate: initialDate,
        dateofservice: initialDate,
        finalDate: finalDate,
        dateofserviceend: finalDate,
        payorId: payorId,
        isSumary: isSumary,
        callTypeIds: callTypeIds,
        providerIds: providerIds,
        driverIds: driverIds,
        payorIds: payorIds,
        tripStatusids : tripStatusIds,
        type: type,
        startdate: initialDate
      };
      return this._http
        .post(url, body, this.getFileHeaders())
        .catch((error: any) => Observable.throw(error.json()));
    }
}

  private getFormatted(date) {
    const month = date.month < 10 ? '0' + date.month : date.month;
    const day = date.day < 10 ? '0' + date.day : date.day;
    return `${date.year}-${month}-${day}`;
  }

  getPayors(path = 'list/?ShowInactive=true') {
    return this._http
      .get(`${constant.URL_PAYOR}/${path}`, this.getHeader())
      .map(res => res.json());
  }
  getCallTypesByPayor(payorId) {
    return this._http
      .get(`${constant.URL_PAYOR}/${payorId}/CallTypes`, this.getHeader())
      .map(res => res.json());
  }

  generateDateRangeReport1(reportPath, isPost = false, isExcel = false) {
    const url = `${constant.BASIC}Report/${reportPath}`;

    const body: any = {
      InitialDate: undefined,
      dateofservice: undefined,
      finalDate: undefined,
      dateofserviceend: undefined,
      payorId: undefined,
      isSumary: undefined,
      callTypeIds: undefined,
      providerIds: undefined,
      driverIds: undefined,
      payorIds: undefined,
      tripStatusids : undefined,
      type: undefined,
      startdate: undefined,
      control : undefined
    };
    return this._http
      .post(url, body, this.getFileHeaders())
      .catch((error: any) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/manager-reports/manager-reports.service.ts